import React from "react";
import { Outlet } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { SiteLayout } from "../components/SiteLayout";

export default function ProjectSite() {
  useTitle("Projects");
  return (
    <SiteLayout>
      <Outlet />
    </SiteLayout>
  );
}
